import { Avatar, Box, IconButton, Paper, Typography } from "@mui/material";
import React from "react";
import Header from "../../components/Header";
import EditIcon from "@mui/icons-material/Edit";
import Sidebar from "../../components/Sidebar";
import EditInterest from "./Modals/EditInterest";
import { useDispatch, useSelector } from "react-redux";
import {
  OPEN_EDIT_ABOUTME,
  OPEN_EDIT_BIO,
  OPEN_EDIT_INTERESTS,
  OPEN_EDIT_LOOKINGFOR,
} from "../../redux/types";
import EditAboutMe from "./Modals/EditAboutMe";
import EditLookingFor from "./Modals/EditLookingFor";
import EditBio from "./Modals/EditBio";
import { useState } from "react";
import { useEffect } from "react";
import {
  updateProfile,
  getProfileInfo,
} from "../../redux/actions/profileActions";
import { useParams } from "react-router-dom";

const Profile = () => {
  const { user } = useSelector((state) => state.Auth);
  const { profile } = useSelector((state) => state.ProfileDetails);
  const [profileImage, setProfileImage] = useState(null);
  const [preview, setPreview] = useState();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   let objectUrl;
  //   if (profileImage) {
  //     objectUrl = URL.createObjectURL(profileImage);
  //     setPreview(objectUrl);
  //     const formData = new FormData();
  //     formData.append("profileImage", profileImage);
  //     // dispatch(updateProfile(formData))
  //   }

  //   return () => {
  //     URL.revokeObjectURL(objectUrl);
  //   };
  // }, [profileImage]);

  const { id } = useParams();
  useEffect(() => {
    dispatch(getProfileInfo(id));
  }, []);

  const handleUpdateImage = (e) => {
    //  setProfileImage(e.target.files[0])

    const formData = new FormData();
    formData.append("profileImage", e.target.files[0]);
    dispatch(updateProfile(formData));
  };

  const authenticated = profile._id === user._id;
  return (
    <div className="bg-slate-50 child:xl:mx-[20rem] child:sm:mx-[5rem] child:md:mx-[12rem] child:mx-[1.4rem] min-h-screen">
      <Header />

      {/* cover photo! */}
      <div
        style={{
          backgroundImage:
            "url(https://my4kwallpapers.com/wp-content/uploads/2021/06/Anime-Wallpaper.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
        className="min-h-[20vh] hidden bg-cover bg-center border rounded-sm  relative ">
        {/* avatar photo */}
        <div className="absolute -bottom-3 left-7 hidden">
          <Avatar
            src={`http://localhost:5000/${profile.profileImage}`}
            className="!h-36 !w-36"
            variant="rounded"
          />
          <div className=" text-xl font-bold capitalize ">
            <p>
              {profile.firstName + " " + profile.lastName}, {profile.age}
            </p>
          </div>

          {authenticated && (
            <div className="bg-black opacity-50 text-white hover:opacity-95 absolute  !h-fit cursor-pointer mx-2 mb-1  bottom-0  text-center font-bold w-[90%] rounded-sm">
              <input
                onChange={handleUpdateImage}
                type="file"
                id="some"
                className="peer z-50 sr-only w-4 h-full  "
              />
              <label
                htmlFor="some"
                className="flex cursor-pointer px-3 py-2 rounded-2xl justify-center items-center font-bold w-full peer-checked:bg-blue-500 peer-checked:text-white text-[17px] text-sm ">
                upload photo
              </label>
            </div>
          )}
        </div>

        {/* user info */}
      </div>

      <div className=" text-xl font-bold capitalize mb-3 mt-4 ">
        <p>
          {profile.firstName + " " + profile.lastName}, {profile.age}
        </p>
      </div>
      {/* bio */}
      <Paper sx={{ padding: "2rem" }}>
        <div className="flex items-center">
          <Typography variant="body2" className="capitalize !font-semibold">
            a few words about myself
          </Typography>
          {authenticated && (
            <IconButton
              className="!ml-3 !mb-2 "
              onClick={() => dispatch({ type: OPEN_EDIT_BIO })}>
              <EditIcon />
            </IconButton>
          )}
        </div>

        <p>{profile.bio}</p>
      </Paper>

      <Box className=" flex flex-col my-5 space-y-5 child:p-3 ">
        {/* interests */}

        <Paper>
          <div className="child:!font-semibold child:capitalize flex items-center justify-between">
            <Typography variant="h6">my interests</Typography>
            {authenticated && (
              <IconButton
                onClick={() => dispatch({ type: OPEN_EDIT_INTERESTS })}>
                <EditIcon />
              </IconButton>
            )}
          </div>
          <div>
            {profile?.interests?.map((x) => (
              <div>{x.name}</div>
            ))}
          </div>
        </Paper>

        {/* about me */}
        <Paper>
          <div className="child:!font-semibold child:capitalize flex items-center justify-between">
            <Typography variant="h6">about me</Typography>

            {authenticated && (
              <IconButton onClick={() => dispatch({ type: OPEN_EDIT_ABOUTME })}>
                <EditIcon />
              </IconButton>
            )}
          </div>
          <ul>
            <li>
              Live in:<strong className="ml-2">{profile.location}</strong>
            </li>
            <li>
              Work as:<strong className="ml-2">{profile.occupation}</strong>
            </li>
            <li>
              Education:
              <strong className="ml-2">{profile.education}</strong>
            </li>
            <li>
              Height:<strong className="ml-2">{profile.height}</strong>
            </li>
            <li>
              Body type:<strong className="ml-2">{profile.bodyType}</strong>
            </li>
            <li>
              MBTI:<strong className="ml-2">{profile.mbti}</strong>
            </li>
          </ul>
        </Paper>

        {/* i am looking for */}
        <Paper>
          <div className="font-medium child:capitalize flex items-center justify-between">
            <Typography variant="h6">
              {profile?.partner?.interestedIn}{" "}
            </Typography>
            {authenticated && (
              <IconButton
                onClick={() => dispatch({ type: OPEN_EDIT_LOOKINGFOR })}>
                <EditIcon />
              </IconButton>
            )}
          </div>
          <p>
            Between ages of {profile?.partner?.ageMin} and{" "}
            {profile?.partner?.ageMax}
          </p>

          <p>
            <strong>about:</strong>
            <br />
            {profile?.partner?.description}
          </p>
        </Paper>
      </Box>

      <Sidebar />
      {/* Modals */}
      <EditInterest />
      <EditAboutMe />
      <EditLookingFor />
      <EditBio />
    </div>
  );
};

export default Profile;
